import useModalClickOutside from "utils/useModalClickOutside";
import CenterModal from "components/common/Modal/CenterModal";
import Button from "components/common/buttons/buttons";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useModalClose } from "lib/analytics/react/modal";

function CacheModal({ setModalOpen, viewHandler, teaserStartHandler }: any) {
  const modalRef = useModalClickOutside(setModalOpen);
  const router = useRouter();
  const { trackClose } = useModalClose();
  return (
    <CenterModal modalRef={modalRef} containerClass="!p-0 w-[355px]">
      <div className="flex flex-col gap-5 pt-5">
        <div className="flex flex-col gap-2 text-center  justify-center items-center">
          <p className={`${TYPO.TYPO7_RG} text-gray60 `}>{`다시 오셨네요!`}</p>
          <p className={`${TYPO.TYPO4_SB} text-gray90 `}>
            {`전에 받았던 진단을 다시 볼까요?`}
          </p>
        </div>

        <div className="flex gap-2 pb-6 px-6">
          <Button
            type="tertiary"
            size="xl"
            text="닫기"
            btnClass="grow flex-1"
            clickHandler={() => {
              teaserStartHandler("retry_modal");
              trackClose("cancel");
              setModalOpen(false);
            }}
          />
          <Button
            type="primary"
            size="xl"
            text="다시 보기"
            clickHandler={() => {
              viewHandler();
              trackClose("success");
              setModalOpen(false);
            }}
            btnClass=" grow flex-1"
          />
        </div>
      </div>
    </CenterModal>
  );
}

export default CacheModal;
